import list from "./regex";
const services = {
    youtube: {
        embededUrl: "https://www.youtube.com/embed/",
        regex: /(http:|https:|)\/\/(player.|www.)?(youtube\.com|\.be|be\.googleapis\.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/gi,
    },
    vimeo: {
        embededUrl: "https://player.vimeo.com/video/",
        regex: /(http:|https:|)\/\/(player.|www.)?(vimeo\.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/gi,
    },
};
export const prependSchemeToUrl = (link) => {
    let matchUrl = link;
    if (!link.match("^https?://")) {
        matchUrl = `http://${matchUrl}`;
    }
    return matchUrl;
};
const GENERAL_REGEX = /(https?:\/\/)?((?<domain>[\w\-~]+)(\.[\w\-~]+)+)(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?/gi;
const EMOJI_REGEX = /^(?:[\u2700-\u27bf ]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])+$/;
const getServicesSource = (tokens) => {
    const linkTokens = tokens.filter((token) => token.type === "link");
    const sources = [];
    linkTokens.forEach((linkToken) => {
        Object.keys(services).forEach((serviceKey) => {
            const service = services[serviceKey];
            const regex = new RegExp(service.regex);
            const matchService = regex.exec(linkToken.link);
            if (matchService) {
                const matchServiceId = matchService[5];
                if (matchServiceId) {
                    const formatUrl = service.embededUrl + matchServiceId;
                    sources.push(formatUrl);
                }
            }
        });
    });
    return sources;
};
const tokenizeMessageText = (message) => {
    const tokens = [];
    const detectedLinks = list(message);
    let startIndex = 0;
    detectedLinks.forEach((detectedLink) => {
        const index = detectedLink.start;
        const text = message.substring(startIndex, index);
        tokens.push({ type: "text", text });
        if (detectedLink.isEmail) {
            tokens.push({ type: "email", email: detectedLink.string });
        }
        if (detectedLink.isURL) {
            tokens.push({ type: "link", link: detectedLink.string });
        }
        startIndex = detectedLink.end;
    });
    if (startIndex < message.length) {
        tokens.push({ type: "text", text: message.substring(startIndex) });
    }
    return tokens;
};
export const isEmoji = (tokenText) => {
    return tokenText.map((token) => EMOJI_REGEX.test(token.text))[0];
};
const detectMessageUrls = (message) => {
    const tokens = tokenizeMessageText(message);
    const mediaUrls = getServicesSource(tokens);
    return [mediaUrls, tokens];
};
export default detectMessageUrls;
//# sourceMappingURL=utils.js.map